import ".././styles/NewsCard.css";
import ".././styles/styles.css";
import { decode } from 'html-entities';
import DefaultImage from ".././assets/pccm_logo.png";

function NewsCard({image, title, date, description, link}) {
    // If the news has no thumbnail, it will use the default image instead
    if(!image){ 
        image = DefaultImage;
    }

    return(
        <div className="news-card-container wrapper">
            <a href={link} target="_blank" rel="noopener noreferrer" className="news-card">
                <div className="img-container">
                    <img className="news-picture" src={image} alt=""></img>
                </div>
                <div className="news-details">
                    <p className="news-title">
                        {decode(title)}
                    </p>
                    <p className="news-description">
                        {decode(description)}
                    </p> 
                    <p className="news-date">
                        {date.substring(0,10) /* This is just to show the date only */}
                    </p>
                </div>
            </a>
        </div>
    );
}

export default NewsCard;